import { useState, useEffect } from "react";
import styled from "styled-components";
import BookService from "../../services/BookService";
import BookCardMini from "./BookCardMini";
import Spinner from "../CommonComponents/Spinner";

const PageWrapper = styled.div`
  padding: 2rem;
  max-width: 1100px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 1.5rem;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Fallback = styled.p`
  color: ${({ theme }) => theme.colors.lineColor};
  font-size: 0.95rem;
`;

function RecommendationsPage({ user }) {
  const [books, setBooks] = useState(null);

  useEffect(() => {
    BookService.getRecommendations(24).then(setBooks).catch(() => setBooks([]));
  }, []);

  if (books === null) return <Spinner />;

  return (
    <PageWrapper>
      <PageTitle>Preporučeno za vas</PageTitle>
      {books.length === 0 ? (
        <Fallback>Posudite više knjiga kako bismo vam mogli preporučiti naslove.</Fallback>
      ) : (
        <Grid>
          {books.map(b => (
            <BookCardMini key={b.id} book={b} user={user} />
          ))}
        </Grid>
      )}
    </PageWrapper>
  );
}

export default RecommendationsPage;
